import type { LexicalEditor } from "lexical";
import type { RowResizeGuide } from "./types";

export function buildRowResizeGuides(editor: LexicalEditor, hoverTableKey: string | null): RowResizeGuide[] {
  const out: RowResizeGuide[] = [];
  if (!hoverTableKey) return out;
  const rootEl = editor.getElementByKey(hoverTableKey);
  const tableDom =
    rootEl instanceof HTMLTableElement
      ? rootEl
      : (rootEl?.querySelector("table") as HTMLTableElement | null);
  if (!tableDom) return out;
  const allRows = tableDom.rows;
  if (allRows.length === 0) return out;
  const tableRect = tableDom.getBoundingClientRect();
  const bandLeft = tableRect.left;
  const bandWidth = tableRect.width;
  for (let i = 0; i < allRows.length; i++) {
    const r = allRows[i].getBoundingClientRect();
    out.push({
      centerY: r.bottom,
      left: bandLeft,
      width: bandWidth,
      rowIndex: i,
      tableKey: hoverTableKey,
    });
  }
  return out;
}
